<!--
 * @Date: 2023-01-10 22:09:04
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-01-18 18:00:12
 * @FilePath: \nicee-web-tw\src\activities\spring-festival\spring-blessing-bag.vue
 * @Description: 新春福袋
-->
<template>
  <div class="spring-blessing-bag">
    <div class="activity-info">
      <div>
        <img class="jewel" src="./images/jewel.png" alt="" />
        <span>每日完成以下任務，可免費獲得福袋鑰匙</span>
      </div>

      <button
        :class="{ active: taskStatus === 0 || taskStatus === 2 }"
        :disabled="taskStatus === 1 || taskStatus === 2"
        @click="receiveKeys"
      >
        {{ taskStatusName }}
      </button>
    </div>
    <ul class="task-box">
      <li class="task-list">
        <span>— 每日瀏覽“新春盛典”活動頁面</span>
        <button class="btn-stage is-completed">已完成</button>
      </li>
      <li class="task-list">
        <span>— 進入語音房逛一逛</span>
        <button
          class="btn-stage"
          :class="{ 'is-completed': taskProgress.joinVioceRoom }"
        >
          {{ taskProgress.joinVioceRoom ? '已完成' : '未完成' }}
        </button>
      </li>
      <li class="task-list">
        <span>— 找陪陪下單並且訂單成交金額不低於100</span>
        <button
          class="btn-stage"
          :class="{ 'is-completed': taskProgress.createOrder }"
        >
          {{ taskProgress.createOrder ? '已完成' : '未完成' }}
        </button>
      </li>
    </ul>
    <div class="bag-number-box">
      <button class="btn-bag-number">
        <span>當前新春福袋鑰匙數量：</span>
        <span>{{ keysCount }}</span>
      </button>
      <button class="btn-bag-buy" @click="handleBuykeys()">
        購買
        <span class="bage">贈送</span>
      </button>
    </div>
    <p class="key-info">
      *福袋鑰匙=60nicee幣/個,新春福袋活動將於決賽結束後同時截止<br />
      *購買一把新春福袋鑰匙，必得應援票x1張<br />
      *黃金寶箱有幾率開出 33440 鉆石禮物！
    </p>
    <div class="content-box">
      <div class="title">
        <img class="jewel" src="./images/jewel.png" alt="" />
        <span>福袋內容說明：</span>
      </div>
      <div class="content">
        <ul class="left">
          <li>
            <img src="./images/diamond.png" class="prize-icon" />
            <span>鑽石*1000</span>
          </li>
          <li>
            <img src="./images/diamond-2.png" class="prize-icon" />
            <span>鑽石*1200</span>
          </li>
          <li>
            <img src="./images/diamond-3.png" class="prize-icon" />
            <span>鑽石*2000</span>
          </li>
          <li>
            <img src="./images/nicee.png" class="prize-icon" />
            <span>nicee幣*66</span>
          </li>
          <li>
            <img src="./images/nicee-2.png" class="prize-icon" />
            <span>nicee幣*288</span>
          </li>
          <li>
            <img src="./images/bag.png" class="prize-icon" />
            <span>黃金寶箱</span>
          </li>
          <li>
            <img src="./images/gift.png" class="prize-icon" />
            <span>可愛天使</span>
          </li>
          <li>
            <img src="./images/answer-tickets.png" class="prize-icon" />
            <span>應援票</span>
          </li>
        </ul>
        <div class="right">
          <!-- <div class="bag">福袋獎勵</div>
          <div class="price">1000nicee幣</div> -->
        </div>
      </div>
    </div>
    <el-dialog
      class="spring-festival-dialog-bg"
      :visible.sync="buyKeysDialog"
      title="提示"
      :show-close="false"
      :append-to-body="true"
    >
      <div class="stepper-box">
        當前想要購買
        <el-input-number v-model="count" size="mini"></el-input-number>
        個福袋鑰匙
      </div>
      <div>
        (需要花費{{ count * price }} nicee幣，可額外獲得{{ count }}張應援票)
      </div>
      <div class="btn-box">
        <el-button
          class="btn-confirm"
          type="info"
          size="small"
          @click="buyKeysDialog = false"
          >取消</el-button
        >
        <el-button
          class="btn-confirm"
          type="primary"
          size="small"
          @click="bugKeys()"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'SpringBlessingBag',
  props: {
    keysCount: {
      typeof: Number,
      default: 0
    },
    price: {
      typeof: Number,
      default: 0
    },
    activityData: {
      typeof: Object,
      default: {}
    }
  },
  data() {
    return {
      count: 1, //钥匙数量
      buyKeysDialog: false
    };
  },
  watch: {},
  computed: {
    taskProgress() {
      return (
        this.activityData.taskProgress || {
          createOrder: false,
          joinVioceRoom: false
        }
      );
    },
    taskStatus() {
      if (this.taskProgress.complateTask) {
        return 2;
      }
      return this.taskProgress.createOrder && this.taskProgress.joinVioceRoom
        ? 0
        : 1;
    },
    taskStatusName() {
      if (this.taskStatus === 0) {
        return '可领取';
      } else if (this.taskStatus === 1) {
        return '未完成';
      } else {
        return '已领取';
      }
    },
    balance() {
      return this.activityData.balance || 0;
    }
  },
  methods: {
    // 打開購買鑰匙的彈窗
    handleBuykeys() {
      this.buyKeysDialog = true;
    },
    closeBuykeysDialog() {
      this.buyKeysDialog = false;
    },
    // 購買鑰匙
    async bugKeys() {
      if (this.balance < this.count * this.price) {
        this.$confirm({
          message: 'nicee幣餘額不足',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        }).then(() => {});
        return;
      }
      try {
        await this.$http.get('/activity/discount', {
          dictType: 'NewYear',
          count: this.count
        });
        this.$confirm({
          message: `成功購買了${this.count}個福袋鑰匙，恭喜額外 獲得${this.count}張盛典應援票`,
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        }).then(() => {
          this.$emit('buy-key-success');
        });
      } catch (error) {
        this.$message('購買福袋鑰匙失敗');
      } finally {
        this.closeBuykeysDialog();
      }
    },

    // 領取鑰匙
    async receiveKeys() {
      try {
        await this.$http.get('/activity/task/summbit', { dictType: 'NewYear' });
        this.$emit('receive-key-success');
        this.$confirm({
          message: `成功領取了新春福袋鑰匙`,
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        });
      } catch (error) {
        this.$message('領取福袋鑰匙失敗');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.spring-blessing-bag {
  margin-top: 10.67rem;
  margin-bottom: 12.75rem;
  font-size: 2rem;
  padding: 0 3.5rem 10.58rem 3.5rem;
  width: 100%;
  color: #e9cc95;
  background: url('./images/blessing-bag-bg.png') no-repeat center top;
  background-size: 100% 100%;
  .activity-info {
    // background: url('./images/day-task.png') no-repeat center top;
    // background-size: 100% auto;
    // background-color: #f6cf8d;
    width: 100%;
    // height: 4.17rem;
    background: linear-gradient(0deg, #cc9247, #f6cf8d);
    // border: 0.08px solid rgba(255, 255, 255, 0.74);
    border-radius: 2.08rem;
    margin-top: 17.04rem;
    display: inline-flex;
    align-items: center;
    padding: 0 3.17rem;
    font-size: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      display: flex;
      align-items: center;
      color: #702400;
    }
    .jewel {
      width: 1.67rem;
      margin-right: 0.58rem;
    }
    button {
      //   background: url('./images/btn-keys.png') no-repeat center top;
      //   background-size: 100% auto;
      //   width: 120px;
      background: rgba(249, 217, 108, 0.6) !important;
      border-radius: 4rem;
      border: 1px solid #ab6a2f;
      // width: 11.5rem;
      height: 4.17rem;
      //   height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2rem;
      color: #702400 !important;
      padding: 1rem;
      margin: 1rem 0 1rem 1rem;
      &.active {
        background: rgba(249, 217, 108, 1) !important;
      }
    }
  }
  .task-box {
    font-size: 2rem;
    color: #e9cc95;
    margin-top: 3.58rem;
    .task-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 6rem;
      border-bottom: 1px solid #452c13;
      .btn-stage {
        width: 8.42rem;
        height: 4rem;
        line-height: 4rem;
        background: url('./images/btn-stage.png') no-repeat center top;
        background-size: 100% auto;
        color: #2c1a0d;
        &.is-completed {
          background: url('./images/btn-stage-complete.png') no-repeat center
            top;
          background-size: 100% auto;
          color: #2c1a0d;
        }
      }
    }
  }
  .bag-number-box {
    display: flex;
    align-items: center;
    margin-top: 5.17rem;
    justify-content: space-between;
    .btn-bag-number {
      background: url('./images/btn-bag-number.png') no-repeat center top;
      background-size: 100% auto;
      display: flex;
      width: 43rem;
      height: 6.5rem;
      display: flex;
      align-items: center;
      padding: 0 1.75rem;
      color: #702400;
      font-size: 2rem;
    }
    .btn-bag-buy {
      background: url('./images/btn-bag-buy.png') no-repeat center top;
      background-size: 100% auto;
      width: 20.5rem;
      height: 6.25rem;
      line-height: 6.25rem;
      position: relative;
      color: #702400;
      font-size: 2.5rem;
      .bage {
        position: absolute;
        display: inline-block;
        width: 4.54rem;
        height: 4.54rem;
        line-height: 4.54rem;
        border-radius: 50%;
        border: 0.17rem solid #ffed8e;
        background-color: #fb5d5d;
        color: white;
        font-size: 1rem;
        right: 0;
        top: 0;
        transform: translate(30%, -40%);
      }
    }
  }
  .key-info {
    font-size: 2rem;
    color: #e9cc95;
    margin-top: 3.75rem;
    line-height: 4rem;
  }
  .content-box {
    margin-top: 6rem;
    .title {
      display: flex;
      align-items: center;
      font-size: 2rem;
      margin-bottom: 4rem;
      .jewel {
        width: 1.67rem;
        margin-right: 1rem;
      }
    }
    .content {
      width: 92.5rem;
      //   height: 370px;
      background: #3d2714;
      border: 1px solid #ab815f;
      border-radius: 3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6.58rem 2.83rem 4.08rem 0;
      .left {
        display: flex;
        // width: 420px;
        flex-wrap: wrap;
        li {
          background: url('./images/prize.png') no-repeat center top;
          background-size: 100% auto;
          width: 12.92rem;
          margin-left: 3.58rem;
          text-align: center;
          font-size: 1rem;
          margin-top: 3.67rem;
          color: #e9cc95;
          span {
            display: block;
          }
          .prize-icon {
            max-width: 100%;
            padding: 2rem;
            margin-bottom: 1.42rem;
          }
        }
      }
      .right {
        flex: none;
        width: 19.17rem;
        height: 20.75rem;
        background: url('./images/max-prize.png') no-repeat center top;
        background-size: 100% auto;
        text-align: center;
        color: #6d3104;
        flex-direction: column;
        justify-content: flex-end;
        display: flex;
        padding-bottom: 0.2rem;
        // .bag {
        //   font-size: 1rem;
        // }
        // .price {
        //   font-size: 2rem;
        // }
      }
    }
  }
}
</style>
